import { useProductInputs } from "@tosize/shapes/src/lib/swr";
import { useMemo } from "react";
import { useConfig } from "../context/ConfigContext";
import { usePostDataContext } from "../context/PostDataContext";

export default function useProducts() {
	const { data: postData } = usePostDataContext();
	const { groupedProduct, apiUrl } = useConfig();
	const { data, error } = useProductInputs(apiUrl, groupedProduct);

	const products = useMemo(() => {
		if (data !== undefined) {
			return Object.entries(data).map(([id, product]) => ({ ...product, id }));
		}

		return undefined;
	}, [data]);

	const product = useMemo(() => postData.product, [postData]);

	const productData = useMemo(() => products?.find((p) => p.id === product), [product, products]);

	const defaultPanel = useMemo(() => {
		return productData?.panelSizes?.find((p) => p.isDefault);
	}, [productData?.panelSizes]);

	return {
		product,
		products,
		productData,
		defaultPanel,
		isLoading: !(error || data),
	} as const;
}
